<template>
  <div>
   <!-- 员工管理组件 -->
   <!-- <EmpView></EmpView> -->
   <router-view></router-view>
  </div>
</template>
<script>
// import EmpView from './views/tlias/EmpView.vue';


export default{
  components: { /* EmpView */ },
  data() {
    return {
      message:"hello vue"
    }
  },
  methods: {
    
  }
}
  
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

</style>
